export const SOCIAL_NETWORKS = {
  vk: {
    name: 'Vk',
    url: 'https://vk.com/fundayshop',
  },
  telegram: {
    name: 'Telegram',
    url: 'https://t.me/fundaystores',
  },
  ok: {
    name: 'Ok',
    url: 'https://www.odnoklassniki.ru/fundayshop',
  },
};
